import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {AdminPanelState} from '../../store/reducers/admin-panel.reducer';
import {select, Store} from '@ngrx/store';
import {FormBuilder, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {GetAllCompaniesAction} from '../../store/actions/admin-panel.action';
import {UserModel} from '../../models/user.model';
import {CompanyModel} from '../../models/company.model';
import {getAllCompanies} from '../../store/selectors/admin-panel.selector';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {takeUntil} from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'lib-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit, OnDestroy {

  addUserForm: any;
  addUserFormErrors: any;
  unSubscribe$ = new Subject<void>();
  companies: CompanyModel[];
  sourceType = 'Admin-Panel';
  result: any;

  constructor(public dialogRef: MatDialogRef<AddUserComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private formBuilder: FormBuilder,
              private store: Store<AdminPanelState>) {
    this.addUserFormErrors = {
      firstName: {},
      lastName: {},
      companyModel: {},
      designation: {},
      username: {},
      email: {}
    };
    this.result = {
      user: null,
      save: false
    };
  }

  ngOnInit() {
    this.store.pipe(select(getAllCompanies), takeUntil(this.unSubscribe$)).subscribe(companies => {
      this.companies = companies;
    });
    this.store.dispatch(new GetAllCompaniesAction());

    this.addUserForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      companyModel: [this.data.company, Validators.required],
      designation: [''],
      username: [''],
      email: ['', Validators.compose([
        Validators.required,
        Validators.pattern("^['a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$")
      ])]
    });

    this.addUserForm.valueChanges.subscribe(() => {
      this.onFormValueChanged();
    });
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onFormValueChanged() {
    for (const field in this.addUserFormErrors) {
      if (!this.addUserFormErrors.hasOwnProperty(field)) {
        continue;
      }

      this.addUserFormErrors[field] = {};
      const control = this.addUserForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.addUserFormErrors[field] = control.errors;
      }
    }
  }

  onSave() {
    if (this.addUserForm.valid) {
      this.addUserForm.controls['firstName'].setValue(this.addUserForm.controls['firstName'].value.trim());
      this.addUserForm.controls['lastName'].setValue(this.addUserForm.controls['lastName'].value.trim());

      const companyModel = this.addUserForm.value.companyModel;
      const companyId = companyModel.companyId;
      const companyName = companyModel.companyName
        ?? this.companies?.find(c => c.companyId === companyId)?.companyName
        ?? '';

      const user = new UserModel({
        firstName: this.addUserForm.value.firstName.trim(),
        lastName: this.addUserForm.value.lastName.trim(),
        companyName: companyName.trim(),
        designation: this.addUserForm.value.designation.trim(),
        username: '',
        email: this.addUserForm.value.email.trim(),
        companyId
      });

      this.result.save = true;
      this.result.user = user;
    }
  }

  public objectComparisonFunction = ( option, value ) : boolean => {
    return option.companyId === value.companyId;
  }

  getCompanyName(companyId) {
    let companyName = '';
    const company = this.companies.find(company => {
      return company.companyId === companyId;
    });

    if (company !== undefined) {
      companyName = company.companyName;
    }

    return companyName;
  }
}
